<template>
  <div class="page-content">
    <h3>这是个人中心</h3>
    <p>这里可以管理个人资料和设置。</p>
  </div>
</template>

<script>
export default {
  name: 'PersonalPage'
}
</script>